<template>
  <!-- eslint-disable vue/no-unused-components -->
  <div>
    <slot v-bind="{ chatroom, members, allMessages, interactions, input }"></slot>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

// import ChatContact         from "./ChatContact.vue"
import ChatLog             from './ChatLog.vue'
// import ChatNavbar          from './ChatNavbar.vue'
import UserProfile         from "./UserProfile.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

let $vm;

export default {
  beforeCreate() { $vm = this },
  async mounted() {
    // await this.fetchAllMemberPublicProfile();
    if (this.$currentUser.active) {
      // await this.getChatRoom();
      await this.chatActivator(this.activator);
    }
  },
  components: {
    VuePerfectScrollbar,
    ChatLog,
    // ChatNavbar,
    // ChatContact,
    UserProfile,
  },
  data() {
    return setDefaultData();
  },
  props: {
    activator: {
      type: Array,
      required: true
    }
  },
  watch: {
    "$store.state.User.currentUser": {
      handler: async function (/* currentUser */) {
        // await this.getChatRoom();
        await this.chatActivator(this.activator);
      },
      deep: true
    },
    "member_ids": {
      /* Watching for changes on member element (in both All, Active and Ban members)
       */
      handler: async function (members, /* prevMembers */) {
        this.members = await this.setAllMemberStatus(members);
      },
      deep: true
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    interactions() {
      return {
        sendMessage: this.sendMessage
      }
    },
  },
  methods: {
    resetChatMessageInput,
    getUserWithPublicProfile,
    chatActivator,
    getChatRoom,
    getChatRoomByAssociativeKey,
    setupChatRoom,
    subscribeToChatRoomChannel,
    setAllMemberStatus,
    processMessageSendingQueue,
    findDiffOfMembers,
    sendMessage,
    onMessageSent
  },
}

function setDefaultData() {
  return {
    chatroom: {
      id: null
    },
    clickNotClose         : false,
    activeChatUser        : 1231231230,
    settings              : {
      maxScrollbarLength    : 60,
      wheelSpeed            : 0.70,
    },
    input: {
      chatMessageInput: { content: "" },
    },
    currentChatMessageSet: {},
    processing: false,
    subscriber: null,
    members: [], // Sorted array of member info objects (including uuid, active status, active timestamp, profiles, ...)
    member_ids: {
      all: [],
      active: [],
      ban: [],
    },
    allMessages: {
      chatMessages: [],
      previousChatMessages: [],
      sendingQueue: [],
      processingQueue: [],
    }
  }
}


async function chatActivator(activator) {
  if (activator) {
    // const associativeKey = `${activator.feature}:${activator.id}`;
    $vm.getChatRoomByAssociativeKey(activator);

    // Set mode for chatroom according to activator calling.
  }
  $vm.error = true;
  $vm.errorStatus = { message: "No Requested Chatroom" }
}

async function getChatRoom(chatroomID) {

  const userUUID = $vm.$currentUser.uuid;

  const chatroom = await $vm.$store.dispatch("Chat/getChatroomById",
    { id: chatroomID, userUUID },
    { root: true }
  );

  if (chatroom.status.success) {
    await $vm.setupChatRoom(chatroom.data);
  }
}

async function getChatRoomByAssociativeKey(keys) {
  if (keys) {
    const chatroom = await $vm.$store.dispatch("Chat/getChatroomByAssociativeKey",
      { associateFeatureInput: keys },
      { root: true }
    );

    if (chatroom.status.success) {
      await $vm.setupChatRoom(chatroom.data);
    }
  }
}

async function setupChatRoom(chatroom) {

  const userUUID = $vm.$currentUser.uuid;

  if (chatroom) {
    $vm.chatroom = chatroom;

    await $vm.subscribeToChatRoomChannel($vm.chatroom, userUUID)

    $vm.currentChatMessageSet = $vm.chatroom.chatMessageSet[0];

    for (let chatMessageSet of $vm.chatroom.chatMessageSet) {
      for (let message of chatMessageSet.messages) {
        $vm.allMessages.chatMessages.push(JSON.parse(message));
      }
      if ($vm.currentChatMessageSet.previousMessages) {
        for (let message of $vm.currentChatMessageSet.previousMessages) {
          $vm.allMessages.previousChatMessage.push(JSON.parse(message));
        }
      }
    }

    // console.log($vm.chatroom.activeUserList);
    $vm.member_ids.active = $vm.chatroom.activeUserList.map(member => JSON.parse(member));
    $vm.member_ids.all = $vm.chatroom.members;
    // $vm.members.ban = $vm.chatroom.bannedUserList;

    // $vm.members = await $vm.setAllMemberStatus($vm.member_ids);
  }
}

async function subscribeToChatRoomChannel(chatroom, userUUID, subscriberInstance) {

  let subscriber = subscriberInstance || $vm.subscriber;

  if (!subscriber && chatroom.id) {
    subscriber = new EventSource(
      process.env.VUE_APP_API_SERVER + "/sse/chatroom/" + chatroom.id
      + "?chatroomID=" + chatroom.id
      + "&userUUID=" + userUUID
    );

    subscriber.onmessage = async (event) => {
      const { signals, payloads } = JSON.parse(event.data);

      if (signals.indexOf("update-chat-messages") > -1) {
        const _newMessages = payloads["update-chat-messages"];
        const newMessages = _newMessages.map(message => JSON.parse(message));
        $vm.allMessages.chatMessages = $vm.allMessages.chatMessages.concat(newMessages);
      }

      if (signals.indexOf("update-member-active") > -1) {
        const { uuid, timestamp } = payloads["update-member-active"];
        if ($vm.member_ids.active.indexOf(uuid) === -1) {
          $vm.member_ids.active.push({ uuid, timestamp });
          $vm.members = await $vm.setAllMemberStatus($vm.member_ids);
        }
      }

      if (signals.indexOf("update-member-inactive") > -1) {
        const { uuid } = payloads["update-member-inactive"];
        $vm.member_ids.active.splice($vm.member_ids.active.indexOf(uuid), 1);  
        $vm.members = await $vm.setAllMemberStatus($vm.member_ids);
      }
    };

    if (!$vm.subscriber) $vm.subscriber = subscriber;

  }
}

async function setAllMemberStatus(members) {
  // To promptly set all member status with public profile for use on subcomponents.
  const diff = $vm.findDiffOfMembers(members);

  const active = members.active.map(({ uuid, timestamp }) => ({ uuid, timestamp, active: true }));

  return await Promise.all(
    [ ...diff, ...active ]
    .sort((a, b) => (a.uuid === b.uuid) ? 0 : a.uuid ? -1 : 1)
    .map(async member => await $vm.getUserWithPublicProfile(member))
    .filter(member => member !== null)
  );
}

function findDiffOfMembers(members) {
  // Find difference of arrays of members be returning only remains of all members array
  // that was reduced from active member list and banned member list.
  const { all, banned } = members;
  const active = members.active.map(member => member.uuid);
  const exclusive = active.concat(banned);
  return all.filter(uuid => exclusive.indexOf(uuid) < 0); // Remember that ALL Member here is not about 7-11. Good!
}

async function getUserWithPublicProfile(member) {
  if (member) {
    const userUUID = member.uuid;

    // Set Flatmap Cache
    if (!$vm.$flatmap.has(userUUID)) {
      const userPublicProfile = await $vm.$store.dispatch("User/getPublicProfile", { userUUID });
      $vm.$flatmap.set(userUUID, userPublicProfile);
    }

    const userPublicProfile = $vm.$flatmap.get(userUUID);

    // Set Fullname
    if (userPublicProfile) {
      userPublicProfile.fullname = userPublicProfile.nameLocal + " " + userPublicProfile.surnameLocal;
      return { ...member, ...userPublicProfile };
    }
  }
  return null;
}

async function sendMessage() {
  const timestamp = new Date().getTime();
  const senderUUID = $vm.$currentUser.uuid;
  const chatMessage = {
    id: $vm.chatroom.id + "/" + timestamp + "/" + senderUUID,
    timestamp,
    senderUUID,
    ...$vm.input.chatMessageInput
  };
  $vm.allMessages.sendingQueue.push(chatMessage);
  $vm.resetChatMessageInput();

  await $vm.processMessageSendingQueue();
}

async function processMessageSendingQueue() {
  // Throttling and sending message in batch
  if ($vm.processing === false) {
    $vm.processing = true;
    $vm.allMessages.processingQueue = [...$vm.allMessages.sendingQueue];
    $vm.allMessages.sendingQueue = [];
    setTimeout(async () => {
      const messageSentResult = await $vm.$store.dispatch("Chat/sendChatMessages",
        {
          chatroomID: $vm.chatroom.id,
          chatMessagesInput: [ ...$vm.allMessages.processingQueue ].map(message => ({ ...message }))
        },
        { root: true }
      );
      $vm.onMessageSent(messageSentResult);
      if ($vm.allMessages.sendingQueue.length > 0) {
        $vm.processMessageSendingQueue();
      }
    }, 500);
  }
}

function onMessageSent(/* messageSentResult */) {
      // const sentMessage = $vm.processingQueue.map(message => ({ ...message, sent: true }));
      // $vm.chatMessages = $vm.chatMessages.concat(sentMessage);
      $vm.processing = false;
      $vm.allMessages.processingQueue = [];
}


function resetChatMessageInput() {
  $vm.input.chatMessageInput = { content: "" };
}

</script>
